import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../api";

import { Row, Col, Label, Input } from 'reactstrap';
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

class AdjuntarModal extends Component {
     constructor(props) {
          super(props);
          this.state = {
               id: null,
               errors: [],
          };
     }

     static propTypes = {
          onSubmit: PropTypes.func,
          id: PropTypes.func,
          action: PropTypes.oneOf(['EDIT', 'DELETE']).isRequired,
     }

     resetForm() {
          this.setState({
               id: null,
               errors: [],
          });
     }

     getData(){
          let formData = new FormData();
          let row = this.props.row();
          if(row != undefined && row != null && row.Codigo != undefined && row.Codigo != null){
               let node = document.getElementById("fichero");
               if(node != undefined && node != null && node.files.length == 1){
                    formData.append("fichero", node.files[0]);
                    formData.append("codigo", row.Codigo);
               }
          }
          return formData;
     }

     setErrors(errors) {
          this.setState({
               errors: errors,
          });
     }

     modalVars() {
          const { action } = this.props;
          const row = this.props.row ? this.props.row() : null;
          if (action == "EDIT") {
               return {
                    edit: true,
                    submitType: "PUT",
                    title: "Adjuntar Fichero",
                    buttonTitle: "Adjuntar Fichero",
                    danger: false,
                    buttonIcon: "fa fa-plus fa-lg",
                    successMessage: "La Operación ha sido éxitosa.",
                    saveButton: true,
                    saveButtonLabel: "Guardar",
                    buttonClass: "",
                    disabled: false,
                    id: () => row ? row.Codigo : false,
                    nombre: () => row ? row.Nombre : false,
                    poseeFichero: () => row ? row.Fichero != undefined && row.Fichero != null && row.Fichero != '' : false,
               };
          } else if (action == "DELETE") {
              return {
                  get: true,
                  submitType: "DELETE",
                  title: "Eliminar Fichero Adjunto",
                  buttonTitle: "Eliminar Fichero",
                  danger: true,
                  buttonIcon: "fa fa-trash fa-lg",
                  successMessage: "La Operación ha sido éxitosa.",
                  saveButton: true,
                  saveButtonLabel: "Eliminar",
                  buttonClass: "btn-danger",
                  disabled: true,
                  id: () => row ? row.Codigo : false,
                  nombre: () => row ? row.Nombre : false,
                  poseeFichero: () => row ? row.Fichero != undefined && row.Fichero != null && row.Fichero != '' : false,
              };
          }
     }

     render() {
          let vars = this.modalVars();
          const { action } = this.props;
          return (
               <ParadigmaModal
                    submitUrl={(vars.submitType ? api.gestion.precios.ficherolistas : null)}
                    submitType={vars.submitType}
                    id={vars.id}

                    onGotErrors={(errors) => this.setErrors(errors)}
                    onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
                    onClose={() => this.resetForm()}
                    onPreSubmit={()=>this.getData()}

                    title={vars.title}

                    danger={vars.danger}
                    buttonClass={vars.buttonClass}

                    successMessage={vars.successMessage}
                    missingIdMessage={"Debe seleccionar una fila."}
                    saveButtonLabel={vars.saveButtonLabel}
                    buttonTitle={vars.buttonTitle}
                    buttonIcon={vars.buttonIcon}
                    saveButton={vars.saveButton}
                    closeButton={true}
               >
               {
                 action == "EDIT" &&
                 <ParadigmaLabeledInput
                      label={"Adjuntar Fichero"}
                      labelColumns={4}
                      fieldColumns={8}
                      inputComponent={<Input type="file" id="fichero" name="fichero" accept="application/pdf,application/vnd.ms-excel" />}
                 />
               }
               {
                 action == "DELETE" && vars.nombre &&
                 <p>¿Desea eliminar fichero adjunto a Lista "{vars.nombre()}"?</p>
               }
               </ParadigmaModal>
          );
     }
}

export default AdjuntarModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Precios/Listas/AdjuntarModal.js